export { default as Avatar, AvatarProps } from '@material-ui/core/Avatar'
